import ClientLeadDetail from './ClientLeadDetail';
import ClientLeadList from './ClientLeadList';
import ClientLeadNew from './ClientLeadNew';
import Status from './Status';

export default {
  ClientLeadDetail,
  ClientLeadList,
  ClientLeadNew,
  Status,
};
